function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.302 6.798c0-1.023.69-1.854 1.545-1.854.853 0 1.545.831 1.545 1.854 0 1.024-.692 1.854-1.545 1.854-.854 0-1.545-.83-1.545-1.853zm-6.49 22.868l2.472-7.416 3.091-6.18-.618-3.709-2.473-8.653h-.618V2.472h12.362v1.236h-.618l-2.473 8.653-.617 3.709 3.09 6.18 2.472 7.416h-1.233l-3.094-6.18-3.708-3.709-3.708 3.709-3.095 6.18H6.811zm3.709-25.958l3.09 6.18h2.473l3.09-6.18H10.52zM1.25 4.944h2.472V1.236H1.25v3.708zm3.708 1.237h2.473V0H4.958v6.18zm21.014-1.237h2.472V1.236h-2.472v3.708zm-3.708 1.237h2.472V0h-2.472v6.18z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "0",
  width: "28",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.302 6.798c0-1.023.69-1.854 1.545-1.854.853 0 1.545.831 1.545 1.854 0 1.024-.692 1.854-1.545 1.854-.854 0-1.545-.83-1.545-1.853zm-6.49 22.868l2.472-7.416 3.091-6.18-.618-3.709-2.473-8.653h-.618V2.472h12.362v1.236h-.618l-2.473 8.653-.617 3.709 3.09 6.18 2.472 7.416h-1.233l-3.094-6.18-3.708-3.709-3.708 3.709-3.095 6.18H6.811zm3.709-25.958l3.09 6.18h2.473l3.09-6.18H10.52zM1.25 4.944h2.472V1.236H1.25v3.708zm3.708 1.237h2.473V0H4.958v6.18zm21.014-1.237h2.472V1.236h-2.472v3.708zm-3.708 1.237h2.472V0h-2.472v6.18z",
  fill: "currentColor"
}))));